import { EntityType } from '../../../@types/entityTypes';
import workspaceQuery from '../../queries/product/ProductMaterialDetailsWorkspaceQuery.graphql';
import fragment from '../../fragments/product/ProductMaterialDetailFragment.graphql';

const ProductMaterialDetail: EntityType = {
  type: 'ProductMaterialDetail',
  title: 'Product Material Details',
  workspaceUrl: '/Products/EPR/ProductMaterialDetails/Workspace/',
  workspace: workspaceQuery,
  fragment: fragment,
  screenReference: 'PRODUCT_MATERIAL_DETAIL',
};

export default ProductMaterialDetail;
